<div class="h-[55vh] w-[50vw]">
  <app-modal-header>
    <div class="flex items-center">
      <div class="p-5">
        <p translate class="text-xl font-semibold text-theme-900" translate>trilhas.relatorio.grafico</p>
      </div>
    </div>
  </app-modal-header>
  <div class="flex h-full w-full flex-col items-start justify-start">
    <ng-container *ngIf="data">
      <div class="flex min-h-[400px] w-full items-center justify-center">
        <div>
          <ngx-charts-pie-chart
            [view]="view"
            [scheme]="colorScheme"
            [results]="data"
            [legend]="true"
            [legendTitle]="'trilhas.relatorio.legenda' | translate"
            [labels]="true"
            [doughnut]="false"
          >
          </ngx-charts-pie-chart>
        </div>
      </div>
    </ng-container>
  </div>
</div>
